///
/// EarthBrowser
///
/// Saved views as command items for the unified Layers panel search:
/// type a view's name (or tag), Enter, and the camera flies there.
///
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

import { sendCameraCommand } from "@/redux/earthBrowserSlice"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { BookmarkIcon } from "lucide-react"
import { useMemo } from "react"
import type { CommandItem } from "./commandTypes"

export function useSavedViewCommands(): CommandItem[] {
	const dispatch = useAppDispatch()
	const views = useAppSelector(state => state.savedViews.views)

	return useMemo(() => {
		return Object.values(views)
			.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
			.map(view => ({
				id: `view-${view.id}`,
				type: 'view' as const,
				title: view.name,
				subtitle: 'Saved view',
				icon: <BookmarkIcon className="w-4 h-4 text-purple-300" />,
				keywords: view.tags,
				action: () => {
					dispatch(sendCameraCommand({
						command: "view/flyTo",
						data: { viewId: view.id }
					}))
				},
				enabled: true
			}))
	}, [views, dispatch])
}
